// frontend/src/uizard/ui/Screen.jsx
import React from "react";

export default function Screen({ children }) {
  return (
    <div>
      {/* Minimal neutral divider */}
      <div className="divider" />
      <main className="container" style={{ paddingTop: 0 }}>
        {children}
      </main>
    </div>
  );
}
